import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'
import Progressbar from 'Pods/Shared/Progressbar'
import cgtraderIcon from 'images/icons/cgt.png'
import GetHighlightedText from 'Utils/GetHighlightedText'
import JsonToQuery from 'Utils/JsonToQuery'

import ProductAnalyticsChart from './ProductAnalyticsChart'
import SalesTooltipContent from './Tooltips/SalesTooltipContent'

function ProductAnalyticsTableRow({
  keyword, maxValues, searchKeyword, searchTerm,
}) {
  const maxPrice = Math.max(maxValues.modelsListingPrice, maxValues.modelsSalePrice)
  const currency = '$'
  const BarColorDefault = '#3b82a0'
  const BarColorListing = '#bcbcbc'
  const BarColorSales = keyword.modelsSalePrice < keyword.modelsListingPrice ? '#ce3c5c' : '#67c4b0'
  const displaySearchLink = searchKeyword && keyword.modelsCount > 0

  return (
    <tr className="table-row--2x">
      <td className={displaySearchLink ? 'is-trigger' : undefined} onClick={() => { displaySearchLink && searchKeyword(keyword.keywords, 2) }}>
        <div className="responsive-table__content">
          {GetHighlightedText(keyword.keywords, searchTerm)}
        </div>
      </td>
      <td>
        {displaySearchLink
        && (
        <a href="javascript:;" className="search-link" onClick={() => { displaySearchLink && searchKeyword(keyword.keywords, 2) }}>
          <Icon type="search" color="grey" />
        </a>
        )
        }
        {keyword.modelsCount > 0
        && (
        <a href={`/3d-models?${JsonToQuery({ keywords: keyword.keywords, strict: 1 })}`} className="search-link" target="_blank">
          <img src={cgtraderIcon} alt="cgtrader" />
        </a>
        )
        }
        <a href={`//www.google.com/search?tbm=isch&${JsonToQuery({ q: keyword.keywords })}`} className="search-link" target="_blank">
          <Icon type={['fab', 'google']} color="grey" size="lg" notSpaced />
        </a>
      </td>
      <td className="chart__is-active">
        <Tooltip
          tooltipClassName="tooltip--chart"
          id={keyword.keywords}
          content={(
            <ProductAnalyticsChart
              labels={Object.keys(keyword.modelsQualityBuckets)}
              data={Object.values(keyword.modelsQualityBuckets)}
              heading="Model distribution by their quality. A lack of high quality objects means an opportunity to
            build better selling/more expensive models."
              leftAxisTitle="Number of models"
              leftAxisOffsetLeft={7}
              title="Model quality distribution"
              color={BarColorDefault}
            />
)}
          event="click focus"
        >
          <Progressbar
            value={keyword.modelsCount}
            maxValue={maxValues.modelsCount}
            labelSize="label-large"
            format="0,0"
          />
        </Tooltip>
      </td>
      <td className="chart__is-active chart__is-double">
        <Tooltip
          tooltipClassName="tooltip--chart"
          id={`${keyword.keywords}-listPrice-${keyword.modelsListingPrice}`}
          content={(
            <div>
              <ProductAnalyticsChart
                labels={Object.keys(keyword.modelsListingPriceBuckets)}
                data={Object.values(keyword.modelsListingPriceBuckets)}
                heading={`Compare <span class="text-light-grey">listing</span> / <span style="color:${BarColorSales}">sales</span> prices
               distributed by price buckets`}
                title="Average <span class='text-light-grey'>listing</span> price distribution"
                leftAxisTitle="Percentage of models"
                color={BarColorListing}
                percentage
              />
              <hr className="is-dashed margin-bottom" />
              <ProductAnalyticsChart
                labels={Object.keys(keyword.modelsSalePriceBuckets)}
                data={Object.values(keyword.modelsSalePriceBuckets)}
                title={`Average <span style="color:${BarColorSales}">sales</span> price distribution`}
                leftAxisTitle="Percentage of models"
                color={BarColorSales}
                percentage
              />
            </div>
)}
          event="click focus"
          place="bottom"
        >
          <Progressbar
            value={keyword.modelsListingPrice}
            maxValue={maxPrice}
            labelSize="label-price"
            currency={currency}
            barColor="is-default"
          />
          <Progressbar
            value={keyword.modelsSalePrice}
            maxValue={maxPrice}
            labelSize="label-price"
            currency={currency}
            compare
            compareValue={keyword.modelsListingPrice}
          />
        </Tooltip>
      </td>
      <td className="chart__is-active">
        <Tooltip
          tooltipClassName="tooltip--sales"
          id={`${keyword.keywords}-sales-${keyword.modelsSalesCount}`}
          content={<SalesTooltipContent percent={keyword.salesPercent} keyword={keyword.keywords} />}
          event="click focus"
        >
          <Progressbar
            value={keyword.modelsSalesCount}
            maxValue={maxValues.modelsSalesCount}
          />
        </Tooltip>
      </td>
      <td>
        <Progressbar
          value={keyword.searchesCount}
          maxValue={maxValues.searchesCount}
        />
      </td>
      <td>
        <Progressbar
          value={keyword.liquidity}
          maxValue={maxValues.liquidity}
          labelSize="label-medium"
        />
      </td>
      <td>
        <Progressbar
          value={keyword.recommendation}
          maxValue={maxValues.recommendation}
        />
      </td>
    </tr>
  )
}

ProductAnalyticsTableRow.propTypes = {
  keyword: PropTypes.object.isRequired,
  maxValues: PropTypes.object.isRequired,
  searchKeyword: PropTypes.func,
  searchTerm: PropTypes.string,
}

ProductAnalyticsTableRow.defaultPropTypes = {
  searchKeyword: null,
  searchTerm: '',
}

export default ProductAnalyticsTableRow
